import { MigrationManifest, PersistedState } from "redux-persist";

import { DialogType, OptionApplicationMenu, DocumentAction } from "@interfaces/slices";

export const migrations: MigrationManifest = {
    0: (state: PersistedState) => {
        return {
            ...state,
            app: {
                ...state.app,
                components: {
                    ...state.app.components,
                    printingProfileReport: {
                        printingMode: false,
                        module: {
                            generalReady: false,
                            downloadSatReady: false,
                            profileReady: false,
                            dashboardReady: false,
                            financialReady: false,
                        },
                    },
                },
            },
        };
    },
    1: (state: PersistedState) => {
        delete state.app["components"];
        return {
            ...state,
            app: {
                ...state.app,
            },
            components: {
                ...state.components,
                dialog: {
                    shown: false,
                    type: DialogType.NONE,
                    props: undefined,
                    onRejectClick: () => {},
                    onAcceptClick: () => {},
                    onCloseClick: () => {},
                },
                buttonPanel: {
                    buttons: [],
                    buttonClicked: {
                        clicked: false,
                        btn: undefined,
                    },
                },
                menuApplication: {
                    optionSelected: OptionApplicationMenu.INFO_GRAL,
                },
                documentAction: {
                    action: DocumentAction.SEE,
                    doc: undefined,
                },
                printingProfileReport: {
                    printingMode: false,
                    module: {
                        generalReady: false,
                        downloadSatReady: false,
                        profileReady: false,
                        dashboardReady: false,
                        financialReady: false,
                    },
                },
                shareholdersStructure: {
                    shareholders: [],
                },
            },
        };
    },
    2: (state: PersistedState) => {
        delete state.components["toAdd"];
        delete state.components["toDelete"];
        delete state.components["toUpdate"];
        return {
            ...state,
            app: {
                ...state.app,
            },
            components: {
                ...state.components,
                shareholdersStructure: {
                    ...state.components.shareholdersStructure,
                    editingMode: false,
                },
            },
        };
    },
    3: (state: PersistedState) => {
        return {
            ...state,
            app: {
                ...state.app,
            },
            components: {
                ...state.components,
                menuApplication: {
                    optionSelected: OptionApplicationMenu.INFO_GRAL,
                },
            },
        };
    },
    4: (state: PersistedState) => {
        return {
            ...state,
            app: {
                ...state.app,
                applicationSelected: {
                    ...state.app.applicationSelected,
                    detalleCanal: "",
                },
            },
        };
    },
    5: (state: PersistedState) => {
        return {
            ...state,
            components: {
                ...state.components,
                popup: {
                    type: PopupType.NONE,
                    props: undefined,
                    anchorEl: undefined,
                },
            },
        };
    },
    6: (state: PersistedState) => {
        return {
            ...state,
            app: {
                ...state.app,
                session: {
                    ...state.app.session,
                    companies: [],
                },
            },
        };
    },
    7: (state: PersistedState) => {
        return {
            ...state,
            app: {
                ...state.app,
                session: {
                    ...state.app.session,
                    user: {
                        ...state.app.sesion.user,
                        role: {
                            name: "",
                            code: "",
                            id: "0-0-0-0-0",
                        },
                    },
                },
            },
        };
    },
    8: (state: PersistedState) => {
        return {
            ...state,
            components: {
                ...state.components,
                usersList: {
                    editingMode: false,
                },
            },
        };
    },
    9: (state: PersistedState) => {
        return {
            ...state,
            components: {
                ...state.components,
                usersList: {
                    ...state.components.usersList,
                    userSelected: {
                        id: "0-0-0-0-0",
                        name: "",
                        lastName: "",
                        lastName2: "",
                    },
                },
            },
        };
    },
    10: (state: PersistedState) => {
        return {
            ...state,
            app: {
                ...state.app,
                components: {
                    ...state.components,
                    opinionModule: {
                        formData: {
                            publicDeedNumber: "",
                            publicDeedDate: "",
                            notaryOfficeNumber: "",
                            notaryName: "",
                            municipality: "",
                            federative: "",
                            sufficientPowers: null,
                            limitationContractCredit: null,
                            commissionerName: "",
                            commissionerLastName: "",
                            commissionerLastName2: "",
                            majorityShareholderValidate: null,
                            legalAgentName: "",
                            legalAgentLastName: "",
                            legalAgentLastName2: "",
                            legalAgentIsShareholder: null,
                        },
                        legalAgentId: "0-0-0-0-0",
                    },
                },
            },
        };
    },
    11: (state: PersistedState) => {
        return {
            ...state,
            app: {
                ...state.app,
                components: {
                    ...state.components,
                    opinionModule: {
                        ...state.components.opinionModule,
                        majorityShareholderId: "0-0-0-0-0",
                    },
                },
            },
        };
    },
    12: (state: PersistedState) => {
        return {
            ...state,
            app: {
                app: {
                    ...state.app,
                    session: {
                        ...state.app.session,
                        source_codes: [],
                    },
                },
                ...state.components,
            },
        };
    },
    13: (state: PersistedState) => {
        return {
            ...state,
            app: {
                ...state.app,
                session: {
                    ...state.app.session,
                    source_codes: [],
                },
            },
        };
    },
    14: (state: PersistedState) => {
        return {
            ...state,
            components: {
                ...state.components,
                backdrop: {
                    visible: false,
                },
            },
        };
    },
    15: (state: PersistedState) => {
        return {
            ...state,
            components: {
                ...state.components,
                currentSection: {
                    module: "",
                },
            },
        };
    },
    16: (state: PersistedState) => {
        return {
            ...state,
            components: {
                ...state.components,
                statusContractualDocs: [],
            },
        };
    },
    17: (state: PersistedState) => {
        return {
            ...state,
            app: {
                ...state.app,
                applicationSelected: {
                    id: "0-0-0-0-0",
                    id_application: 0,
                    company_name: "",
                    comercial_name: "",
                    company_rfc: "",
                    user_name: "",
                    user_email: "",
                    requested_amount: 0,
                    requested_term: 0,
                    approved_amount: 0,
                    approved_term: 0,
                    screen_time_seconds: 0,
                    total_time_seconds: 0,
                    client_total_time_seconds: 0,
                    last_status_date: "",
                    stage_name: "",
                    substage_name: "",
                    status_name: "",
                    status_code: "",
                    channel: "",
                    channel_id: "",
                    detail_channel: "",
                    macrochannel: "",
                    assigned_partner: "",
                    assigned_partner_email: "",
                    interested: false,
                    msol_total_comments: 0,
                    mrev_total_comments: 0,
                    mpin_total_comments: 0,
                    mrec_total_comments: 0,
                    maut_total_comments: 0,
                    mcli_total_comments: 0,
                    client_detail_id: "0-0-0-0-0",
                    stage: {
                        id: "0-0-0-0-0",
                        name: "",
                        description: "",
                    },
                    substage: {
                        id: "0-0-0-0-0",
                        name: "",
                        description: "",
                        stage_id: "0-0-0-0-0",
                    },
                    status: {
                        id: "0-0-0-0-0",
                        name: "",
                        description: "",
                        substage_id: "0-0-0-0-0",
                        code: "",
                    },
                    tax_system: {
                        id: "0-0-0-0-0",
                        name: "",
                        code: "",
                        product_id: "0-0-0-0-0",
                        tax_system_type: "",
                    },
                    dictamenCompletado: false,
                    company_docs_validated: false,
                    shareholder_docs_validated: false,
                    owners_docs_validated: false,
                    existsSDC: false,
                    credit_validated: null,
                    pld_validated: null,
                    legal_incidents_validated: null,
                    visit_analysis_validated: null,
                    check_control_validated: null,
                    disburment_date: "",
                    product_id: "0-0-0-0-0",
                },
            },
        };
    },
    18: (state: PersistedState) => {
        return {
            ...state,
            app: {
                ...state.app,
                session: {
                    ...state.app.session,
                    financial_inc: {
                        id: "0-0-0-0-0",
                        code: "",
                    },
                },
            },
        };
    },
    19: (state: PersistedState) => {
        return {
            ...state,
            components: {
                ...state.components,
                currentSection: {
                    ...state.components.currentSection,
                    section: "",
                },
            },
        };
    },
    20: (state: PersistedState) => {
        return {
            ...state,
            components: {
                ...state.components,
                layout: {
                    sidebar: {
                        expandState: false,
                    },
                },
            },
        };
    },
    21: (state: PersistedState) => {
        return {
            ...state,
            components: {
                ...state.components,
                currentSection: {
                    ...state.components.currentSection,
                    reload: true,
                },
            },
        };
    },
    22: (state: PersistedState) => {
        return {
            ...state,
            components: {
                ...state.components,
                lists: {
                    filters: {
                        companies: [],
                    },
                },
            },
        };
    },
    23: (state: PersistedState) => {
        return {
            ...state,
            auth: {
                isAuthenticate: false,
                isVerified: false,
                signInStep: "LOGIN",
            },
        };
    },
    24: (state: PersistedState) => {
        return {
            ...state,
            session: {
                ...state.session,
                user: {
                    ...state.session.user,
                    preferences: {
                        theme: "light",
                        avatar: {
                            color: "#FFF",
                            initials: "",
                        },
                        sessionOptions: {
                            persist: false,
                            durationDays: 15,
                        },
                    },
                },
            },
        };
    },
    25: (state: PersistedState) => {
        return {
            ...state,
            session: {
                ...state.session,
                permissionsV2: [],
            },
        };
    },
    26: (state: PersistedState) => {
        return {
            ...state,
            components: {
                ...state.components,
                menuApplication: {
                    ...state.components.menuApplication,
                    lock: false,
                },
            },
        };
    },
    27: (state: PersistedState) => {
        return {
            ...state,
            components: {
                ...state.components,
                lists: {
                    current: "",
                    shared_filters: {
                        companies: state.components.lists.filters.companies ?? [],
                        financials: state.components.lists.filters.financials ?? {
                            id: "0-0-0-0-0",
                            code: "",
                            name: "",
                        },
                    },
                    configList: [],
                },
            },
        };
    },
    28: (state: PersistedState) => {
        return {
            ...state,
            components: {
                ...state.components,
                lists: {
                    ...state.components.lists,
                    shared_filters: {
                        ...state.components.lists.shared_filters,
                        fullSearch: {
                            text: "",
                            searching: false,
                        },
                    },
                },
            },
        };
    },
};
